import InputRadioText from "./Input.Radio.Text";

export default InputRadioText;